import { callApi } from '@/utils/api'
import type { DroneInfo } from '@/types/droneInfo'
import type { ApiMessage, ApiMessageIds } from '@/types/apiResponse'
/**
 * /drone_infos を呼び出す(取得)
 */
export async function fetchDroneInfo(): Promise<DroneInfo | ApiMessage> {
  return await callApi<DroneInfo>('/drone-infos', 'GET')
}

/**
 * /drone_infos を呼び出す(更新)
 */
export async function updateDroneInfo(droneInfo: DroneInfo): Promise<ApiMessage | ApiMessageIds> {
  return await callApi<ApiMessage | ApiMessageIds, DroneInfo>('/drone-infos', 'PUT', droneInfo)
}
